import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-shebei",
  "use": "icon-shebei-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-shebei\"><defs><style type=\"text/css\"></style></defs><path d=\"M937.6 176L784 329.6 694.4 240 800 134.4l48-48C736 16 588.8 28.8 489.6 124.8c-70.4 70.4-96 169.6-80 259.2l-352 352c-25.6 25.6-25.6 64 0 89.6L192 960c25.6 25.6 64 25.6 89.6 0l352-352c89.6 19.2 188.8-9.6 259.2-80 102.4-92.8 115.2-240 44.8-352z m-86.4 313.6c-64 64-153.6 80-233.6 51.2L243.2 918.4 108.8 784l377.6-377.6c-28.8-80-9.6-169.6 51.2-233.6C592 118.4 665.6 99.2 736 112l-83.2 83.2L608 240l182.4 182.4 131.2-131.2c6.4 70.4-16 144-70.4 198.4z\" p-id=\"10172\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-shebei.svg
// module id = WwY4
// module chunks = 177